import { sanitizeUrl } from '@braintree/sanitize-url';
import { IPublicRestaurant, Label, MessageType, MessageUtils } from '@localina/core';
import { TextBlockIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    restaurant: IPublicRestaurant;
    type: MessageType;
    // caption above the message; omitted where the page heading already says what it is
    title?: string;
}

export const Message: React.FC<IProps> = (props) => {
    const { i18n } = useTranslation();

    const message = props.restaurant.messages.find((it) => it.type === props.type);
    const preferredLanguages = [i18n.language, ...(navigator.languages ?? [])];
    const displayText = message && MessageUtils.getLocalizedDisplayText(message, preferredLanguages);

    const handleLink = () => {
        const link = sanitizeUrl(message?.link || '');
        if (link) {
            window.open(link, '__blank');
        }
    };

    return displayText ? (
        <div className="message">
            {props.title && (
                <div className="widget-field__label">
                    <TextBlockIcon />
                    <span>{props.title}</span>
                </div>
            )}
            <div className="message__body">
                <Label type="text" value={displayText.text} />
                {message?.link && (
                    <Label type="link" value={displayText.link ?? sanitizeUrl(message?.link)} onClick={handleLink} />
                )}
            </div>
        </div>
    ) : (
        <></>
    );
};
